// dependency-graph-ignore-file
import { createContextMenuEffect } from '@databases/context-menu/context-menu-effect';
import { getCachedViewSnapshotForSelections } from '@databases/database-state';
import { type DatabaseAdapter } from '@databases/selections-api-types';
import { getService } from '@databases/service-container';

import { type SelectionEffectFeature, SelectionFeatureKeys } from '../../features/types';

export function createContextMenuEffectFeature(deps: {
  contentId: string;
  databaseAdapter: DatabaseAdapter;
}): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.CONTEXT_MENU_EFFECT,
    type: 'effect',
    // Always active — the context menu internally checks permissions
    // when building menu items. Removing the entire effect would
    // prevent the right-click menu from appearing at all.
    factory: () =>
      createContextMenuEffect({
        selectionsApi: getService('SelectionsApi'),
        databaseAdapter: deps.databaseAdapter,
        contentId: deps.contentId,
        currentViewId: getCachedViewSnapshotForSelections().id,
        formatMessage: getService('Intl').formatMessage,
        panelManager: getService('PanelManager'),
        selectionsActions: getService('SelectionsActions'),
        highlightsController: getService('TableHighlightsController'),
        selectionsReader: getService('SelectionsReader'),
      }),
  };
}
